import { useCallback, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { SeasonsDocument, useCreateSeasonMutation } from '../../../../schema';
import { toast } from 'react-toastify';
import { FORM_ERROR, SubmissionErrors } from 'final-form';

export type CreateSeasonFormValues = {
  title: string;
  start: string;
  end: string;
  description: string;
  brandColor: string;
  imageId: string;
  currencyIconId: string;
  nominativeSingular: string;
  genitiveSingular: string;
  genitivePlural: string;
  accusativePlural: string;
};

export const useCreateSeasonForm = () => {
  const history = useHistory();

  const [createSeason, { data, loading, error }] = useCreateSeasonMutation();

  const initialValues: CreateSeasonFormValues = {
    title: '',
    start: '',
    end: '',
    description: '',
    brandColor: '',
    imageId: '',
    currencyIconId: '',
    nominativeSingular: '',
    genitiveSingular: '',
    genitivePlural: '',
    accusativePlural: '',
  };

  const onCancel = useCallback(() => {
    history.push('/battle-pass/seasons');
  }, [history]);

  const onSubmit = useCallback(
    async (values: CreateSeasonFormValues) => {
      const generalInformation = {
        title: values.title,
        start: values.start,
        end: values.end,
        description: values.description,
        brandColor: values.brandColor || null,
        imageId: values.imageId,
      };

      const currency = {
        iconId: values.currencyIconId,
        name: {
          nominativeSingular: values.nominativeSingular,
          genitiveSingular: values.genitiveSingular,
          genitivePlural: values.genitivePlural,
          accusativePlural: values.accusativePlural,
        },
      };

      try {
        await createSeason({
          variables: {
            input: {
              generalInformation,
              currency,
            },
          },
          refetchQueries: [{ query: SeasonsDocument }],
        });
      } catch {
        toast.error('Ошибка создания сезона');
        return { [FORM_ERROR]: 'Ошибка создания сезона' } as SubmissionErrors;
      }
    },
    [createSeason]
  );

  useEffect(() => {
    if (data !== undefined) {
      toast.success('Сезон успешно создан');
      onCancel();
    }
  }, [data, onCancel]);

  useEffect(() => {
    if (error) {
      toast.error('Ошибка создания сезона');
    }
  }, [error]);

  return {
    initialValues,
    onSubmit,
    onCancel,
    loading,
  };
};
